// src/redux/testLib/testLibSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { GetAllTests } from '../../vlp/services/TestLibService'; // <-- adjust path if needed

// Async thunk to load tests (uses your existing service)
export const fetchTestLib = createAsyncThunk(
  'testLib/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await GetAllTests();
      // support two possible shapes: { statusCode, results } or direct array
      const tests = response && response.results ? response.results : response;
      return tests || [];
    } catch (err) {
      return rejectWithValue(err?.message || 'Failed to fetch test library');
    }
  }
);

const initialState = {
  data: [],          // array of TestlibSearchDto-like objects
  status: 'idle',    // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

const testLibSlice = createSlice({
  name: 'testLib',
  initialState,
  reducers: {
    // Optional local setters for manual updates
    setTestLib: (state, action) => {
      state.data = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
    clearTestLib: (state) => {
      state.data = [];
      state.status = 'idle';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestLib.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(fetchTestLib.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.data = action.payload;
      })
      .addCase(fetchTestLib.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export const { setTestLib, clearTestLib } = testLibSlice.actions;

// Selectors
export const selectTestLibData = (state) => state.testLib.data;
export const selectTestLibStatus = (state) => state.testLib.status;
export const selectTestLibError = (state) => state.testLib.error;

export default testLibSlice.reducer;
